import _ from "lodash";
import fetchData from "./fetchData";
import * as query from './queries';

const parse = (str) => str.split('_').map((val, i) => i > 0 ? val[0].toUpperCase() + val.substring(1) : val).join('');

const cloneAttributes = (target, source) => {
    return [...source.attributes].forEach(attr => {
        target.setAttribute(attr.nodeName === "id" ? 'data-id' : attr.nodeName, attr.nodeValue)
    });
}

function scrollToTargetAdjusted(element, offset) {
    let headerOffset = offset;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition - headerOffset;

    window.scrollBy({
        top: offsetPosition,
        behavior: "smooth"
    });
}

//splide
if (document.querySelector('.splide-working')) {
    let splideClients = new Splide('.splide-working', {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        speed: 600,
        easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
        pagination: false,
        arrows: false,
        fixedWidth: '26.25vw',
        fixedHeight: '33.854166666666664vw',
        gap: 16,
        breakpoints: {
            769: {
                gap: 8,
                fixedWidth: '65vw',
                fixedHeight: '84.73333333333333vw',
            },
        }
    }).mount();
}
//
const splideInit = function (selector) {
    return new Splide(selector, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        speed: 600,
        easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
        pagination: false,
        arrows: false,
        fixedWidth: '26.25vw',
        fixedHeight: '33.854166666666664vw',
        gap: 16,
        breakpoints: {
            769: {
                gap: 8,
                fixedWidth: '65vw',
                fixedHeight: '84.73333333333333vw',
            },
        }
    });
}

const fetchField = async function (fieldState, pageId, templateName, graphlQLName, fieldGroup, office, selectorContentToReplace, state = 'none') {

    const parsedField = parse(fieldGroup);
    const result = await query.getField(fieldState, pageId, templateName, graphlQLName, parsedField, office);

    try {
        if (fieldState === 'text' || fieldState === 'img') {
            var {
                data: {
                    page: {
                        template:
                            {
                                [graphlQLName]:
                                    {
                                        [parsedField]:
                                            {all, estonia, latvia, lithuania}
                                    }
                            }
                    }
                }
            } = result;
        }

        if (fieldState === 'repeater-2-philosophy' || fieldState === 'repeater' || fieldState === 'repeater-carousel' || fieldState === 'carousel-2' || fieldState === 'repeater-2' || fieldState === 'repeater-policy-3' || fieldState === 'group-3' || fieldState === 'repeater-3' || fieldState === 'repeater-m-2') {
            var {
                data: {
                    page: {
                        template:
                            {
                                [graphlQLName]: {
                                    [parsedField]: repeaterResponse
                                }
                            }
                    }
                }
            } = result;
        }
        //

        //converting to html
        const htmlConversion = function (convertStr, classToAdd) {
            // if (!all && !estonia && !latvia && !lithuania && !repeaterResponse) return;

            if (fieldState === 'repeater-m-2') {
                const block = sel(selectorContentToReplace);

                if (!block.querySelector('.left-side .tabs .single-tabs')) return;

                const tabsBackup = block.querySelector('.left-side .tabs .single-tabs').cloneNode(true);
                const categoryWrapperBackup = block.querySelector('.right-side .category-wrapper').cloneNode(true);
                const singleCategoryBackup = block.querySelector('.right-side .category-wrapper .single-category').cloneNode(true);

                const tabs = block.querySelector('.left-side .tabs');
                const rightSide = block.querySelector('.right-side');

                tabs.innerHTML = '';
                rightSide.innerHTML = '';
                categoryWrapperBackup.querySelector('.categories').innerHTML = '';

                //
                const field1 = office + '1';
                const field2 = office + '2';
                const fieldRep1 = `${office}${office.charAt(0).toUpperCase() + office.slice(1)}`;

                _.each(repeaterResponse, (val, i) => {
                    const {[field1]: firstField, [field2]: services} = val;

                    const cloneTab = tabsBackup.cloneNode(true);
                    cloneTab.querySelector('h2').textContent = firstField;

                    const categoryWrapperClone = categoryWrapperBackup.cloneNode(true);

                    if (i > 0) {
                        cloneTab.classList.remove('active');
                        categoryWrapperClone.classList.remove('active');
                    }

                    _.each(services, val => {
                        if (!val[fieldRep1]?.title && !val[fieldRep1]?.target && !val[fieldRep1]?.url) return;

                        let {[fieldRep1]: {target, title, url}} = val
                        const singleCategoryClone = singleCategoryBackup.cloneNode(true);

                        singleCategoryClone.querySelector('a').setAttribute('href', url);
                        singleCategoryClone.querySelector('a').setAttribute('target', target);
                        title = title.replaceAll('&amp;', '');
                        singleCategoryClone.querySelector('a').textContent = title;

                        categoryWrapperClone.querySelector('.categories').insertAdjacentElement('beforeend', singleCategoryClone);
                    });

                    rightSide.insertAdjacentElement('beforeend', categoryWrapperClone);
                    tabs.insertAdjacentElement('beforeend', cloneTab);
                });

                const leftTabs = document.querySelectorAll('.page-home .left-side .single-tabs');
                const rightTabs = document.querySelectorAll('.page-home .category-wrapper');
                const darkSection = document.querySelector('.dark-section .content > .right-side');

                //first active by default
                leftTabs.forEach(t => {
                    t.classList.add('inactive');
                });
                leftTabs[0].classList.remove('inactive');
                rightTabs[0].classList.add('active');
                leftTabs[0].classList.add('active');
                darkSection.style.minHeight = `${rightTabs[0].clientHeight / (document.documentElement.clientWidth / 100)}vw`;

                leftTabs.forEach((tab, i) => {
                    tab.addEventListener('mouseover', () => {
                        leftTabs.forEach(t => {
                            if (t !== tab)
                                t.classList.add('inactive');
                        });

                        rightTabs.forEach(val => {
                            val.classList.remove('active');
                        });

                        tab.classList.remove('inactive');
                        tab.classList.add('active');
                        rightTabs[i].classList.add('active');

                        darkSection.style.minHeight = `${rightTabs[i].clientHeight / (document.documentElement.clientWidth / 100)}vw`;
                    });

                    tab.addEventListener('mouseout', () => {
                        leftTabs.forEach(tab => {
                            tab.classList.remove('active');
                            tab.classList.remove('inactive');
                        });

                        darkSection.style.minHeight = `10vw`;
                        rightTabs[i].classList.remove('active');

                        //first active by default
                        leftTabs.forEach(t => {
                            t.classList.add('inactive');
                        });
                        leftTabs[0].classList.remove('inactive');
                        rightTabs[0].classList.add('active');
                        leftTabs[0].classList.add('active');
                        darkSection.style.minHeight = `${rightTabs[0].clientHeight / (document.documentElement.clientWidth / 100)}vw`;
                    });
                });

                rightTabs.forEach((tab, i) => {
                    tab.addEventListener('mouseover', () => {
                        leftTabs.forEach(tab => {
                            // if (!tab.classList.contains('active'))
                            //     tab.classList.add('inactive');
                            tab.classList.add('inactive');
                        });

                        leftTabs[i].classList.add('inactive');

                        rightTabs.forEach(val => {
                            val.classList.remove('active');
                        });

                        // tab.classList.remove('inactive');
                        tab.classList.add('active');
                        leftTabs[i].classList.remove('inactive');
                        leftTabs[i].classList.add('active');

                        darkSection.style.minHeight = `${rightTabs[i].clientHeight / (document.documentElement.clientWidth / 100)}vw`;
                    });

                    tab.addEventListener('mouseout', () => {
                        leftTabs.forEach(tab => {
                            tab.classList.remove('active');
                            tab.classList.remove('inactive');
                        });

                        rightTabs.forEach(tab => tab.classList.remove('active'));
                        darkSection.style.minHeight = `10vw`;

                        //first active by default
                        leftTabs.forEach(t => {
                            t.classList.add('inactive');
                        });
                        leftTabs[0].classList.remove('inactive');
                        rightTabs[0].classList.add('active');
                        leftTabs[0].classList.add('active');
                        darkSection.style.minHeight = `${rightTabs[0].clientHeight / (document.documentElement.clientWidth / 100)}vw`;
                    });
                });


                //mobile
                const mobileBlock = sel('.mobile-tabs');
                const singleTabClone = mobileBlock?.firstElementChild.cloneNode(true);
                const singleCategoryClone = mobileBlock.querySelector('.single-category-mob').cloneNode(true);

                const cols = singleTabClone.querySelectorAll('.col-mob');
                _.each(cols, col => {
                    col.innerHTML = '';
                });
                mobileBlock.innerHTML = '';

                let first = '';

                _.each(repeaterResponse, (val, i) => {
                    const {[field1]: firstField, [field2]: services} = val;

                    const cloneSingleTabMob = singleTabClone.cloneNode(true);
                    cloneSingleTabMob.querySelector('h2').textContent = firstField;

                    _.each(services, (val, j) => {
                        if (!val[fieldRep1]?.title && !val[fieldRep1]?.target && !val[fieldRep1]?.url) return;

                        const {[fieldRep1]: {target, title, url}} = val

                        const categorySingleAdd = singleCategoryClone.cloneNode(false);
                        const createLink = document.createElement('a');

                        createLink.setAttribute('href', url);
                        createLink.setAttribute('target', target);
                        createLink.textContent = title;

                        categorySingleAdd.insertAdjacentElement('beforeend', createLink);
                        if (j % 2 === 0) {
                            cloneSingleTabMob.querySelector('.col-mob-1').insertAdjacentElement('beforeend', categorySingleAdd);
                        } else {
                            cloneSingleTabMob.querySelector('.col-mob-2').insertAdjacentElement('beforeend', categorySingleAdd);
                        }
                    });
                    //

                    if (i === 0) {
                        first = cloneSingleTabMob;
                    }

                    if (i !== 0) {
                        cloneSingleTabMob.classList.remove('active');
                    }

                    mobileBlock.insertAdjacentElement('beforeend', cloneSingleTabMob);
                });

                // first.click();

                jQuery(document).ready(function ($) {
                    if (document.querySelector('.dark-section-mobile .mobile-tabs')) {
                        const mobileTabs = selAll('.mobile-tabs .single-tabs-mob');
                        const tabTitle = selAll('.mobile-tabs .tab-title-mob');
                        const firstExpand = sel('.mobile-tabs .single-tabs-expand');
                        const darkSectionMobile = sel('.dark-section-mobile');

                        $('body').on('click', '.single-tabs-mob', function (e) {
                            $('.mobile-tabs').find('.single-tabs-expand').stop().slideUp();
                            $(this).closest('.single-tabs-mob').find('.single-tabs-expand').stop().slideToggle();

                            // setTimeout(() => {
                            //     scrollToTargetAdjusted(darkSectionMobile, 0);
                            // }, 500);

                            if (this.classList.contains('active')) {
                                mobileTabs.forEach(val => val.classList.remove('active'));
                                tabTitle.forEach(val => val.classList.remove('inactive'));

                            } else {
                                mobileTabs.forEach(val => val.classList.remove('active'));
                                tabTitle.forEach(val => val.classList.add('inactive'));
                                this.classList.add('active');
                                this.querySelector('.tab-title-mob').classList.remove('inactive');
                            }
                        });

                        mobileTabs[0].click();
                    }
                });
            }

            if (fieldState === 'repeater-2-philosophy' && repeaterResponse) {
                const block = sel(selectorContentToReplace);

                const clone1 = block.querySelector('.top-content .single-text').cloneNode(true);
                const clone2 = block.querySelector('.content .single-philosophy').cloneNode(true);

                const topContent = block.querySelector('.top-content');
                const content = block.querySelector('.content .philosophy-options');

                if (block) {
                    topContent.innerHTML = '';
                    content.innerHTML = '';

                    const field1 = office + '1';
                    const field2 = office + '2';

                    _.each(repeaterResponse, ({[field1]: firstField, [field2]: secondField}) => {
                        const cloneTopContent = clone1.cloneNode(true);
                        const cloneBottomContent = clone2.cloneNode(true);

                        cloneTopContent.innerHTML = '';
                        cloneBottomContent.querySelector('h5').innerHTML = '';

                        cloneTopContent.innerHTML = secondField;
                        cloneBottomContent.querySelector('h5').innerHTML = firstField;

                        topContent.insertAdjacentElement('beforeend', cloneTopContent);
                        content.insertAdjacentElement('beforeend', cloneBottomContent);
                    });
                }

                const philosophyText = document.querySelectorAll('.triniti-philosophy-section .top-content > .single-text');
                const philosophy = document.querySelectorAll('.triniti-philosophy-section .philosophy-options > .single-philosophy');

                philosophy.forEach((val, i) => {
                    val.addEventListener('mouseover', () => {

                        philosophy.forEach((val, j) => {
                            if (i != j) val.classList.add('inactive');
                        });

                        philosophyText[i].classList.add('active');
                        val.classList.add('active');
                    });

                    val.addEventListener('mouseout', () => {
                        philosophy.forEach(val => val.classList.remove('inactive'));
                        val.classList.remove('active');
                        philosophyText[i].classList.remove('active');
                    });

                    philosophyText[i].addEventListener('mouseover', () => {
                        philosophy.forEach((val, j) => {
                            if (i != j) val.classList.add('inactive');
                        });

                        philosophyText[i].classList.add('active');
                        val.classList.add('active');
                    });

                    philosophyText[i].addEventListener('mouseout', () => {
                        philosophy.forEach(val => val.classList.remove('inactive'));
                        val.classList.remove('active');
                        philosophyText[i].classList.remove('active');
                    });
                });
            }

            if (fieldState === 'group-3') {
                const block = sel(selectorContentToReplace);
                const leftSideTitle = block.querySelector('.left-side .caption h5');
                const rightSideTopText = block.querySelector('.right-side .text');
                const rightSideBottomText = block.querySelector('.right-side .caption');

                leftSideTitle.textContent = '';
                rightSideTopText.innerHTML = '';
                rightSideBottomText.innerHTML = '';

                const field1 = office + '1';
                const field2 = office + '2';
                const field3 = office + '3';

                const {[field1]: firstField, [field2]: secondField, [field3]: thirdField} = repeaterResponse;

                leftSideTitle.textContent = firstField;
                rightSideTopText.innerHTML = secondField;
                rightSideBottomText.innerHTML = thirdField;
            }

            if (fieldState === 'repeater-3') {
                const block = sel(selectorContentToReplace);
                const leftSideBackup = block.firstElementChild.firstElementChild.cloneNode(true);
                const rightSideBackup = block.lastElementChild.firstElementChild.firstElementChild.cloneNode(true);
                const singleInfo = leftSideBackup.querySelector('.right-side-inner .single-info').cloneNode(true);

                if (leftSideBackup && rightSideBackup && singleInfo) {

                    block.firstElementChild.innerHTML = '';
                    block.lastElementChild.firstElementChild.innerHTML = '';

                    //empty left
                    leftSideBackup.querySelector('.left-side-inner .title h2').textContent = '';
                    leftSideBackup.querySelector('.right-side-inner').innerHTML = '';
                    singleInfo.querySelector('.title').innerHTML = '';

                    if (singleInfo.querySelector('.btn-stroke')) {
                        singleInfo.querySelector('.btn-stroke').innerHTML = '';
                    }
                    //

                    const field1 = office + '1';
                    const field2 = office + '2';
                    const field3 = office + '3';

                    const fieldRep1 = `${office}${office.charAt(0).toUpperCase() + office.slice(1)}1`;
                    const fieldRep2 = `${office}${office.charAt(0).toUpperCase() + office.slice(1)}2`;

                    _.each(repeaterResponse, (val) => {
                        const {
                            [field1]: firstField, [field2]: {sourceUrl}, [field3]: thirdField
                        }
                            = val;

                        const singleOffice = leftSideBackup.cloneNode(true);
                        const leftSideInner = singleOffice.querySelector('.left-side-inner .title h2');
                        const rightSideInner = singleOffice.querySelector('.right-side-inner');

                        leftSideInner.textContent = firstField;

                        const rightPhoto = rightSideBackup.cloneNode(true);
                        rightPhoto.style.background = `url(${sourceUrl}) center / cover no-repeat`;

                        _.each(thirdField, val => {
                            const {[fieldRep1]: fieldRep1TItle} = val;
                            const singleInfoClone = singleInfo.cloneNode(true);
                            singleInfoClone.querySelector('.title').innerHTML = fieldRep1TItle;

                            if (val[fieldRep2]) {
                                const {[fieldRep2]: {title, target, url}} = val;

                                const anchor = document.createElement('a');

                                anchor.setAttribute('href', url);
                                anchor.setAttribute('target', target);
                                anchor.textContent = title;

                                singleInfoClone.querySelector('.btn-stroke')?.insertAdjacentElement('beforeend', anchor);
                            }

                            rightSideInner.insertAdjacentElement('beforeend', singleInfoClone);
                        });

                        block.firstElementChild.insertAdjacentElement('beforeend', singleOffice);
                        block.lastElementChild.firstElementChild.insertAdjacentElement('beforeend', rightPhoto);
                    });

                    const photo = selAll('.our-offices-section .right-photos-sticky .photo');
                    const singleOffice = selAll('.our-offices-section .single-office');

                    let crossed = [];

                    function officeCheck(passArr) {
                        passArr.forEach((val, i) => {
                            if (val.getBoundingClientRect().top - document.documentElement.clientHeight / 2 < 0) {
                                crossed.push(val);
                                if (!sel('.page-insights')) {
                                    crossed.forEach(val => {
                                        let blur = val.querySelector('.blured');
                                        blur.classList.remove('active');
                                    });
                                }

                                photo.forEach(ph => ph.classList.remove('active'));
                                photo[i].classList.add('active');

                                crossed[crossed.length - 1].querySelector('.blured').classList.add('active');
                            }
                        });
                    }

                    officeCheck(singleOffice)
                    window.addEventListener('scroll', () => officeCheck(singleOffice));

                    const officesMobile = sel('.our-offices-mobile .content-mobile');
                    const singleContBackup = officesMobile.firstElementChild.cloneNode(true);
                    const sinInfoWrapperBackup = officesMobile.querySelector('.single-info').cloneNode(true);

                    if (sinInfoWrapperBackup.querySelector('.btn-stroke')) {
                        sinInfoWrapperBackup.querySelector('.btn-stroke').innerHTML = '';
                    }

                    officesMobile.querySelector('.sin-info-wrapper').innerHTML = '';
                    singleContBackup.querySelector('.sin-info-wrapper').innerHTML = '';
                    officesMobile.innerHTML = '';

                    _.each(repeaterResponse, (val) => {
                        const {
                            [field1]: firstField, [field2]: {sourceUrl}, [field3]: thirdField
                        }
                            = val;

                        const singleClone = singleContBackup.cloneNode(true);
                        singleClone.querySelector('.photo').style.background = `url(${sourceUrl}) center / cover no-repeat`;
                        singleClone.querySelector('.right-side h2').textContent = firstField;

                        _.each(thirdField, val => {
                            const {[fieldRep1]: fieldRep1TItle} = val;
                            const singleInfoClone = sinInfoWrapperBackup.cloneNode(true);

                            singleInfoClone.querySelector('.title').innerHTML = fieldRep1TItle;

                            if (val[fieldRep2]) {
                                const {[fieldRep2]: {title, target, url}} = val;
                                const anchor = document.createElement('a');

                                anchor.setAttribute('href', url);
                                anchor.setAttribute('target', target);
                                anchor.textContent = title

                                singleInfoClone.querySelector('.btn-stroke').insertAdjacentElement('beforeend', anchor);
                            }

                            singleClone.querySelector('.sin-info-wrapper').insertAdjacentElement('beforeend', singleInfoClone);
                        });

                        officesMobile.insertAdjacentElement('beforeend', singleClone);
                    });
                }
            }

            if (fieldState === 'repeater-policy-3' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const backup = block?.firstElementChild;
                block.innerHTML = '';

                const field1 = office + '1';
                // const field2 = office + '2';
                const field3 = office + '3';

                _.each(repeaterResponse, ({[field1]: firstField, [field3]: thirdField}) => {
                    const cloneDiv = backup.cloneNode(true);

                    cloneDiv.querySelector('.heading h5').innerHTML = firstField;
                    // cloneDiv.querySelector('.content .left-side .text').innerHTML = secondField;
                    cloneDiv.querySelector('.content .right-side .main-text').innerHTML = thirdField;
                    block.insertAdjacentElement('beforeend', cloneDiv);
                });
            }

            if (fieldState === 'repeater-2' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const backup = block?.firstElementChild;
                block.innerHTML = '';

                const field1 = office + '1';
                const field2 = office + '2';

                _.each(repeaterResponse, ({[field1]: firstField, [field2]: secondField}) => {
                    const cloneDiv = backup.cloneNode(true);

                    cloneDiv.querySelector('.title h4').innerHTML = firstField;
                    cloneDiv.querySelector('.text').innerHTML = secondField;
                    block.insertAdjacentElement('beforeend', cloneDiv);
                });
            }

            if (fieldState === 'carousel-2' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block?.firstElementChild);

                block.innerHTML = '';

                const field1 = office + '1';
                const field2 = office + '2';
                //
                _.each(repeaterResponse, ({[field1]: firstField, [field2]: secondField}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder);

                    const firstText = document.createElement('div');
                    firstText.className = 'hovered-text';
                    firstText.innerHTML = firstField;

                    const secondText = document.createElement('div');
                    secondText.className = 'text';

                    const h5 = document.createElement('h5');
                    h5.textContent = secondField;

                    //inserting
                    secondText.insertAdjacentElement('beforeend', h5);
                    createDiv.insertAdjacentElement('beforeend', firstText);
                    createDiv.insertAdjacentElement('beforeend', secondText);
                    block.insertAdjacentElement('beforeend', createDiv);
                });


                let num = 0;

                if (screenWidth.matches)
                    num = 0;

                let splideClients = new Splide('.splide-milestones', {
                    type: 'slide',

                    start: num,
                    perPage: 4,
                    perMove: 1,
                    speed: 600,
                    easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                    pagination: false,
                    arrows: false,
                    flickPower: 1000,
                    flickMaxPages: 1,
                    fixedWidth: '14vw',
                    width: '90vw',
                    // autoplay: true,
                    // interval: 3500,
                    // pauseOnHover: true,
                    breakpoints: {
                        769: {
                            start: num,
                            focus: 0,
                            perPage: 3,
                            fixedWidth: '50.4vw',
                        },
                    }
                }).mount();

                splideClients.on('click', ({index}) => {
                    splideClients.go(index);
                });

                // splideClients.on('click', (i) => {
                //     splideClients.go(i);
                // });

            } else if (_.includes(fieldState, 'text')) {
                const replace = sel(selectorContentToReplace);
                replace.innerHTML = '';

                const convert = document.createElement('div');
                convert.innerHTML = convertStr;

                if (_.includes(state, 'animated')) {
                    // console.log(convert);
                    // convert?.firstElementChild?.classList.add(classToAdd);
                    const ps = convert.querySelectorAll('p');

                    _.each(ps, p => {
                        p.classList.add(classToAdd)
                    });
                    replace.insertAdjacentElement('beforeend', convert);
                } else {
                    convert.classList.add(classToAdd);
                    replace.insertAdjacentElement('beforeend', convert);
                }

            } else if (_.includes(fieldState, 'img')) {
                const replaceImg = sel(selectorContentToReplace);
                const url = convertStr.sourceUrl;
                replaceImg.style.background = `url(${url}) center / cover no-repeat`;
            } else if (fieldState === 'repeater' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block?.firstElementChild);

                block.innerHTML = '';
                _.each(repeaterResponse, ({[office]: content}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder)
                    createDiv.innerHTML = content;
                    block.insertAdjacentElement('beforeend', createDiv);
                });
            } else if (fieldState === 'repeater-carousel' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block?.firstElementChild);

                block.innerHTML = '';
                _.each(repeaterResponse, ({[office]: {sourceUrl}}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder);

                    const photo = document.createElement('div');
                    photo.className = 'photo';
                    photo.style.background = `url(${sourceUrl}) center / cover no-repeat`;

                    createDiv.insertAdjacentElement('beforeend', photo);
                    block.insertAdjacentElement('beforeend', createDiv);
                });

                let splideClients = new Splide('.splide-working', {
                    type: 'loop',
                    perPage: 4,
                    perMove: 1,
                    speed: 600,
                    easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                    pagination: false,
                    arrows: false,
                    fixedWidth: '26.25vw',
                    fixedHeight: '33.854166666666664vw',
                    gap: 16,
                    breakpoints: {
                        769: {
                            gap: 8,
                            fixedWidth: '65vw',
                            fixedHeight: '84.73333333333333vw',
                        },
                    }
                }).mount();
            }
        }
        //

        switch (office) {
            case 'all': {
                htmlConversion(all, 'animated');
                break;
            }
            case 'estonia': {
                htmlConversion(estonia, 'animated');
                break;
            }
            case 'latvia': {
                htmlConversion(latvia, 'animated');
                break;
            }
            case 'lithuania': {
                htmlConversion(lithuania, 'animated');
                break;
            }
        }
    } catch (e) {

    }
}

const fetchPostField = async function (fieldState, pageId, postName, fieldGroup, office, selectorContentToReplace, state = 'none') {
    try {
        const parsedField = parse(fieldGroup);
        const result = await query.getPostField(fieldState, pageId, postName, parsedField, office);
        const graphQlPost = `postType${postName.charAt(0).toUpperCase() + postName.slice(1)}`;

        if (fieldState === 'text' || fieldState === 'img') {
            var {
                data: {
                    [postName]: {
                        [graphQlPost]: {
                            [parsedField]:
                                {all, estonia, latvia, lithuania}
                        }
                    }
                }
            } = result;
        }

        if (fieldState === 'repeater' || fieldState === 'repeater-2' || fieldState === 'repeater-4') {
            var {
                data: {
                    [postName]: {
                        [graphQlPost]: {
                            [parsedField]: repeaterResponse
                        }
                    }
                }
            } = result;
        }

        const htmlConversion = function (convertStr, classToAdd) {
            // if (!all && !estonia && !latvia && !lithuania && !repeaterResponse) return;

            if (fieldState === 'text') {
                const replace = sel(selectorContentToReplace);
                replace.innerHTML = '';
                const convert = document.createElement('div');
                convert.innerHTML = convertStr;

                if (_.includes(state, 'animated')) {
                    convert.firstElementChild.classList.add(classToAdd);
                    replace.insertAdjacentElement('beforeend', convert);

                    const ps = convert.querySelectorAll('p');

                    ps.forEach(val => {
                        val.classList.add(classToAdd);
                    });
                } else {
                    convert.classList.add(classToAdd);
                    replace.insertAdjacentElement('beforeend', convert);
                }

            } else if (fieldState === 'repeater') {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block?.firstElementChild);

                block.innerHTML = '';

                _.each(repeaterResponse, ({[office]: content}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder)
                    createDiv.innerHTML = content;
                    block.insertAdjacentElement('beforeend', createDiv);
                });

                if (selectorContentToReplace.includes('full-text')) {
                    if (sel('.single-people') || sel('.single-services')) {
                        if (sel('.read-more-btn')) {

                            const readMoreBtn = document.querySelectorAll('.read-more-btn');
                            const fullDescription = sel('.full-description');
                            const getHeight = sel('.full-description .full-text').clientHeight;
                            let clicked = false;

                            if (fullDescription.classList.contains('active')) {
                                fullDescription.classList.remove('active');
                                fullDescription.style.height = '0';
                            }

                            readMoreBtn.forEach(btn => btn.addEventListener('click', function () {
                                clicked = !clicked;

                                if (clicked) {
                                    fullDescription.classList.add('active');
                                    fullDescription.style.height = `${getHeight / (document.documentElement.clientWidth / 100)}vw`;
                                } else {
                                    fullDescription.style.height = `0`;
                                    fullDescription.classList.remove('active');
                                }
                            }));
                        }
                    }
                }
            } else if (fieldState === 'repeater-2') {
                const block = sel(selectorContentToReplace);
                const backup = block?.firstElementChild;

                if (block) {
                    block.innerHTML = '';
                    const field1 = office + '1';
                    const field2 = office + '2';

                    _.each(repeaterResponse, ({[field1]: firstField, [field2]: secondField}) => {
                        const cloneDiv = backup.cloneNode(true);

                        if (selectorContentToReplace.includes('.personal-table .table-content')) {
                            cloneDiv.querySelector('.single-not-expanded .title h4').innerHTML = firstField;
                            cloneDiv.querySelector('.single-expanded .country-info .single-country .country-title h2').innerHTML = secondField;
                            block.insertAdjacentElement('beforeend', cloneDiv);
                        }

                        if (selectorContentToReplace.includes('.single-service-client-help .table-body')) {
                            cloneDiv.querySelector('.position h4').innerHTML = firstField;
                            //change to href
                            cloneDiv.querySelector('.single-item').setAttribute('href', secondField);
                            block.insertAdjacentElement('beforeend', cloneDiv);
                        }
                    });
                }
            } else if (fieldState === 'repeater-4') {
                const block = sel(selectorContentToReplace);
                const backupLeft = block?.firstElementChild.firstElementChild;
                const backupRight = block?.lastElementChild.firstElementChild;
                block.firstElementChild.innerHTML = '';
                block.lastElementChild.innerHTML = '';

                const field1 = office + '1';
                const field2 = office + '2';
                const field3 = office + '3';
                const field4 = office + '4';

                _.each(repeaterResponse, ({
                                              [field1]: firstField,
                                              [field2]: secondField,
                                              [field3]: thirdField,
                                              [field4]: lastField
                                          }, i) => {

                    const cloneDivLeft = backupLeft.cloneNode(true);
                    const cloneDivRight = backupRight.cloneNode(true);

                    if (i > 0) {
                        cloneDivRight.classList.remove('active');
                        cloneDivLeft.classList.remove('active');
                    }

                    //right side
                    cloneDivRight.insertAdjacentHTML('afterbegin', secondField);
                    const title = cloneDivRight.children;
                    const filterTitle = _.reject(title, el => el.classList.contains('capt'));

                    filterTitle[filterTitle.length - 1].remove();

                    const year = cloneDivRight.querySelector('.capt:first-of-type');
                    const tier = cloneDivRight.querySelector('.capt:last-of-type');
                    //

                    //inserting texts
                    cloneDivLeft.querySelector('h5').textContent = firstField;

                    year.textContent = thirdField;
                    tier.textContent = lastField;
                    //

                    block?.firstElementChild.insertAdjacentElement('beforeend', cloneDivLeft);
                    block?.lastElementChild.insertAdjacentElement('beforeend', cloneDivRight);
                });

                if (document.querySelector('.caption-section')) {
                    const captionSectionLeft = document.querySelectorAll('.caption-section .left-side .caption');
                    const captionSectionRight = document.querySelectorAll('.caption-section .right-side .text');


                    captionSectionLeft.forEach((val, i) => val.addEventListener('click', () => {
                        captionSectionLeft.forEach(val => val.classList.remove('active'));
                        val.classList.add('active');

                        captionSectionRight.forEach(vak => vak.classList.remove('active'));
                        captionSectionRight[i].classList.add('active');
                    }));
                }
            }
        }

        switch (office) {
            case 'all': {
                htmlConversion(all, 'animated');
                break;
            }
            case 'estonia': {
                htmlConversion(estonia, 'animated');
                break;
            }
            case 'latvia': {
                htmlConversion(latvia, 'animated');
                break;
            }
            case 'lithuania': {
                htmlConversion(lithuania, 'animated');
                break;
            }
        }
    } catch (err) {
    }
}


const fetchTranslatedPostField = async function (fieldState, pageId, postName, fieldGroup, office) {
    const parsedField = parse(fieldGroup);
    const result = await query.getField(fieldState, pageId, postName, parsedField, office);

    if (fieldState === 'text' || fieldState === 'img') {
        var {
            data: {}
        } = result;
    }

    if (fieldState === 'repeater') {

    }

    if (fieldState === 'repeater-2') {

    }
}

const fetchTranslatedField = async function (fieldState, pageId, templateName, graphlQLName, fieldGroup, office, selectorContentToReplace, state = 'none') {
    const parsedField = parse(fieldGroup);
    const result = await query.getField(fieldState, pageId, templateName, graphlQLName, parsedField, office);

    //dynamic data destructuring
    //as genijus?
    try {
        if (fieldState === 'text' || fieldState === 'img') {
            var {
                data: {
                    page: {
                        template:
                            {
                                [graphlQLName]:
                                    {
                                        [parsedField]:
                                            {all, estonia, latvia, lithuania}
                                    }
                            }
                    }
                }
            } = result;
        }

        if (fieldState === 'repeater' || fieldState === 'repeater-carousel' || fieldState === 'carousel-2' || fieldState === 'repeater-2' || fieldState === 'group-3' || fieldState === 'repeater-3' || fieldState === 'repeater-m-2' || fieldState === 'repeater-2-philosophy') {
            var {
                data: {
                    page: {
                        template:
                            {
                                [graphlQLName]: {
                                    [parsedField]: repeaterResponse
                                }
                            }
                    }
                }
            } = result;
        }
        //

        //converting to html
        const htmlConversion = function (convertStr, classToAdd) {

            if (fieldState === 'repeater-m-2') {
                const block = sel(selectorContentToReplace);
                const tabsBackup = block.querySelector('.left-side .tabs .single-tabs').cloneNode(true);
                const tabs = block.querySelector('.left-side .tabs');
                const rightSide = block.querySelector('.right-side');
            }

            if (fieldState === 'group-3') {
                const block = sel(selectorContentToReplace);
                const leftSideTitle = block.querySelector('.left-side .caption h5');
                const rightSideTopText = block.querySelector('.right-side .text h4');
                const rightSideBottomText = block.querySelector('.right-side .caption');

                leftSideTitle.textContent = '';
                rightSideTopText.innerHTML = '';
                rightSideBottomText.innerHTML = '';

                const field1 = office + '1';
                const field2 = office + '2';
                const field3 = office + '3';

                const {[field1]: firstField, [field2]: secondField, [field3]: thirdField} = repeaterResponse;

                leftSideTitle.textContent = firstField;
                rightSideTopText.innerHTML = secondField;
                rightSideBottomText.innerHTML = thirdField;
            }

            if (fieldState === 'repeater-3') {
                const block = sel(selectorContentToReplace);
                const leftSideBackup = block.firstElementChild.firstElementChild.cloneNode(true);
                const rightSideBackup = block.lastElementChild.firstElementChild.firstElementChild.cloneNode(true);
                const singleInfo = leftSideBackup.querySelector('.right-side-inner .single-info').cloneNode(true);

                block.firstElementChild.innerHTML = '';
                block.lastElementChild.firstElementChild.innerHTML = '';

                //empty left
                leftSideBackup.querySelector('.left-side-inner .title h2').textContent = '';
                leftSideBackup.querySelector('.right-side-inner').innerHTML = '';
                singleInfo.querySelector('.title').innerHTML = '';
                singleInfo.querySelector('.btn-stroke').innerHTML = '';
                //

                const field1 = office + '1';
                const field2 = office + '2';
                const field3 = office + '3';

                const fieldRep1 = `${office}${office.charAt(0).toUpperCase() + office.slice(1)}1`;
                const fieldRep2 = `${office}${office.charAt(0).toUpperCase() + office.slice(1)}2`;

                _.each(repeaterResponse, (val) => {
                    const {
                        [field1]: firstField, [field2]: {sourceUrl}, [field3]: thirdField
                    }
                        = val;

                    const singleOffice = leftSideBackup.cloneNode(true);
                    const leftSideInner = singleOffice.querySelector('.left-side-inner .title h2');
                    const rightSideInner = singleOffice.querySelector('.right-side-inner');

                    leftSideInner.textContent = firstField;

                    const rightPhoto = rightSideBackup.cloneNode(true);
                    rightPhoto.style.background = `url(${sourceUrl}) center / cover no-repeat`;

                    _.each(thirdField, val => {
                        const {[fieldRep1]: fieldRep1TItle, [fieldRep2]: {title, target, url}} = val;

                        const singleInfoClone = singleInfo.cloneNode(true);
                        singleInfoClone.querySelector('.title').innerHTML = fieldRep1TItle;

                        const anchor = document.createElement('a');

                        anchor.setAttribute('href', url);
                        anchor.setAttribute('target', target);
                        anchor.textContent = title;

                        singleInfoClone.querySelector('.btn-stroke')?.insertAdjacentElement('beforeend', anchor);
                        rightSideInner.insertAdjacentElement('beforeend', singleInfoClone);
                    });

                    block.firstElementChild.insertAdjacentElement('beforeend', singleOffice);
                    block.lastElementChild.firstElementChild.insertAdjacentElement('beforeend', rightPhoto);
                });

                const photo = selAll('.our-offices-section .right-photos-sticky .photo');
                const singleOffice = selAll('.our-offices-section .single-office');

                let crossed = [];

                function officeCheck(passArr) {
                    passArr.forEach((val, i) => {
                        if (val.getBoundingClientRect().top - document.documentElement.clientHeight / 2 < 0) {
                            crossed.push(val);
                            if (!sel('.page-insights')) {
                                crossed.forEach(val => {
                                    let blur = val.querySelector('.blured');
                                    blur.classList.remove('active');
                                });
                            }

                            photo.forEach(ph => ph.classList.remove('active'));
                            photo[i].classList.add('active');

                            crossed[crossed.length - 1].querySelector('.blured').classList.add('active');
                        }
                    });
                }

                officeCheck(singleOffice)
                window.addEventListener('scroll', () => officeCheck(singleOffice));
            }

            if (fieldState === 'repeater-2' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const backup = block.firstElementChild;

                if (block) {
                    block.innerHTML = '';

                    const field1 = office + '1';
                    const field2 = office + '2';

                    _.each(repeaterResponse, ({[field1]: firstField, [field2]: secondField}) => {
                        const cloneDiv = backup.cloneNode(true);

                        cloneDiv.querySelector('.title h4').innerHTML = firstField;
                        cloneDiv.querySelector('.text').innerHTML = secondField;
                        block.insertAdjacentElement('beforeend', cloneDiv);
                    });
                }
            }

            if (fieldState === 'carousel-2' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block.firstElementChild);

                block.innerHTML = '';

                const field1 = office + '1';
                const field2 = office + '2';
                //
                _.each(repeaterResponse, ({[field1]: firstField, [field2]: secondField}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder);

                    const firstText = document.createElement('div');
                    firstText.className = 'hovered-text';
                    firstText.innerHTML = firstField;

                    const secondText = document.createElement('div');
                    secondText.className = 'text';

                    const h5 = document.createElement('h5');
                    h5.textContent = secondField;

                    //inserting
                    secondText.insertAdjacentElement('beforeend', h5);
                    createDiv.insertAdjacentElement('beforeend', firstText);
                    createDiv.insertAdjacentElement('beforeend', secondText);
                    block.insertAdjacentElement('beforeend', createDiv);
                });


                let num = 1;

                if (screenWidth.matches)
                    num = 0;

                let splideClients = new Splide('.splide-milestones', {
                    type: 'slide',

                    start: num,
                    perPage: 4,
                    perMove: 1,
                    speed: 600,
                    easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                    pagination: false,
                    arrows: false,
                    fixedWidth: '14vw',
                    width: '90vw',
                    flickPower: 1000,
                    flickMaxPages: 1,
                    // autoplay: true,
                    // interval: 3500,
                    // pauseOnHover: true,
                    breakpoints: {
                        769: {
                            start: num,
                            focus: 0,
                            perPage: 3,
                            fixedWidth: '50.4vw',
                        },
                    }
                }).mount();

                splideClients.on('click', ({index}) => {
                    splideClients.go(index);
                });

            } else if (_.includes(fieldState, 'text')) {
                const replace = sel(selectorContentToReplace);
                replace.innerHTML = '';

                const convert = document.createElement('div');
                convert.innerHTML = convertStr;

                if (_.includes(state, 'animated')) {
                    convert.firstElementChild.classList.add(classToAdd);
                    replace.insertAdjacentElement('beforeend', convert);
                } else {
                    convert.classList.add(classToAdd);
                    replace.insertAdjacentElement('beforeend', convert);
                }

            } else if (_.includes(fieldState, 'img')) {
                const replaceImg = sel(selectorContentToReplace);
                const url = convertStr.sourceUrl;
                replaceImg.style.background = `url(${url}) center / cover no-repeat`;
            } else if (fieldState === 'repeater' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block.firstElementChild);

                block.innerHTML = '';
                _.each(repeaterResponse, ({[office]: content}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder)
                    createDiv.innerHTML = content;
                    block.insertAdjacentElement('beforeend', createDiv);
                });
            } else if (fieldState === 'repeater-carousel' && repeaterResponse) {
                const block = sel(selectorContentToReplace);
                const attributeHolder = document.createElement('div');
                cloneAttributes(attributeHolder, block.firstElementChild);

                block.innerHTML = '';
                _.each(repeaterResponse, ({[office]: {sourceUrl}}) => {
                    const createDiv = document.createElement('div');
                    cloneAttributes(createDiv, attributeHolder);

                    const photo = document.createElement('div');
                    photo.className = 'photo';
                    photo.style.background = `url(${sourceUrl}) center / cover no-repeat`;

                    createDiv.insertAdjacentElement('beforeend', photo);
                    block.insertAdjacentElement('beforeend', createDiv);
                });

                let splideClients = new Splide('.splide-working', {
                    type: 'loop',
                    perPage: 4,
                    perMove: 1,
                    speed: 600,
                    easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                    pagination: false,
                    arrows: false,
                    fixedWidth: '26.25vw',
                    fixedHeight: '33.854166666666664vw',
                    gap: 16,
                    breakpoints: {
                        769: {
                            gap: 8,
                            fixedWidth: '65vw',
                            fixedHeight: '84.73333333333333vw',
                        },
                    }
                }).mount();
            }
        }
        //

        switch (office) {
            case 'all': {
                htmlConversion(all, 'animated');
                break;
            }
            case 'estonia': {
                htmlConversion(estonia, 'animated');
                break;
            }
            case 'latvia': {
                htmlConversion(latvia, 'animated');
                break;
            }
            case 'lithuania': {
                htmlConversion(lithuania, 'animated');
                break;
            }
        }
    } catch (e) {

    }
}

export {fetchField, fetchTranslatedField, fetchPostField, fetchTranslatedPostField};